var app = angular.module('leonardo');

let RecurrenceFilter = function (TemplateService) {
  return function (template) {
    if (template && !isNull(template.recurrence_type)) {
      switch (template.recurrence_type.toString()) {
        case 'document':
          return 'Documents';
        case 'workflow':
          return 'Workflows';
        case 'work-order':
          return 'Work Orders';
        case TemplateService.RECURRENCE_DAILY:
          return 'Daily';
        case TemplateService.RECURRENCE_FIXED_DATE:
          if (template.recurrence && template.recurrence.yearly) {
            return 'Daily - Yearly';
          }
          else {
            return 'Fix Date';
          }
        // case TemplateService.RECURRENCE_WEEKLY:
        //   var options = [];
        //   if (template.recurrence) {
        //     if (template.recurrence.sunday) {
        //       options.push('Sun');
        //     }
        //     if (template.recurrence.monday) {
        //       options.push('M');
        //     }
        //     if (template.recurrence.tuesday) {
        //       options.push('T');
        //     }
        //     if (template.recurrence.wednesday) {
        //       options.push('W');
        //     }
        //     if (template.recurrence.thursday) {
        //       options.push('Th');
        //     }
        //     if (template.recurrence.friday) {
        //       options.push('F');
        //     }
        //     if (template.recurrence.saturday) {
        //       options.push('Sat');
        //     }
        //   }
        //   return options.join(', ');
        case TemplateService.RECURRENCE_WEEKLY:
          return 'Weekly';
        case TemplateService.RECURRENCE_MONTHLY:
          return 'Monthly';
        case TemplateService.RECURRENCE_YEARLY:
          return 'Yearly';
        default:
          return template.recurrence_type;
      }
    }
    return '-';
  };
};

let RecurrenceTemplateFilter = function (TemplateService) {
  return function (template) {
    let options = [];
    if (template && !isNull(template.recurrence_type)) {
      switch (template.recurrence_type.toString()) {
        case 'document':
          return 'Documents';
        case 'workflow':
          return 'Workflows';
        case 'work-order':
          return 'Work Orders';
        case TemplateService.RECURRENCE_DAILY:
          return 'Daily';
        case TemplateService.RECURRENCE_FIXED_DATE:
          if (template.recurrence.yearly) {
            return 'Daily - Yearly';
          }
          else {
            if (template.recurrence && template.recurrence.fixed_date_conditions) {
              switch (template.recurrence.fixed_date_conditions.type) {
                case 'fixed_day':
                  return moment(template.recurrence.fixed_date_conditions.date).format('MMM DD, YYYY');
                case 'day_of_month':
                  let daymonth = (template.recurrence.fixed_date_conditions.every_x_months > 1) ? ' months' : ' month';
                  return 'Day ' + template.recurrence.fixed_date_conditions.day + ' of every ' +
                    template.recurrence.fixed_date_conditions.every_x_months + daymonth;
                case 'relative_day_of_month':
                  let relativemonth = (template.recurrence.fixed_date_conditions.every_x_months > 1) ? ' months' : ' month';
                  return 'The ' + TemplateService.RECURRENCE_POSITION_IN_MONTH.find(d => d.id === parseInt(template.recurrence.fixed_date_conditions.weekday_position_in_month)).name + ' '
                    + TemplateService.RECURRENCE_WEEKLY_OPTIONS.find(d => d.id === parseInt(template.recurrence.fixed_date_conditions.weekday)).name
                    + ' of every ' + template.recurrence.fixed_date_conditions.every_x_months + relativemonth;
              }
            }
            else {
              return 'Invalid recurrence';
            }
          }
          break;
        case TemplateService.RECURRENCE_WEEKLY:
          options = [];
          if (template.recurrence) {
            if (template.recurrence.sunday) {
              options.push('Sun');
            }
            if (template.recurrence.monday) {
              options.push('M');
            }
            if (template.recurrence.tuesday) {
              options.push('T');
            }
            if (template.recurrence.wednesday) {
              options.push('W');
            }
            if (template.recurrence.thursday) {
              options.push('Th');
            }
            if (template.recurrence.friday) {
              options.push('F');
            }
            if (template.recurrence.saturday) {
              options.push('Sat');
            }
          }
          return options.join(', ');
        case TemplateService.RECURRENCE_MONTHLY:
          options = [];
          if (template.recurrence) {
            if (template.recurrence.week1) {
              options.push('1st');
            }
            if (template.recurrence.week2) {
              options.push('2nd');
            }
            if (template.recurrence.week3) {
              options.push('3rd');
            }
            if (template.recurrence.last_week) {
              options.push('Last');
            }
          }
          return options.join(', ') + ' Week';
        case TemplateService.RECURRENCE_YEARLY:
          options = [];
          if (template.recurrence) {
            if (template.recurrence.january) {
              options.push('Jan');
            }
            if (template.recurrence.february) {
              options.push('Feb');
            }
            if (template.recurrence.march) {
              options.push('Mar');
            }
            if (template.recurrence.april) {
              options.push('Apr');
            }
            if (template.recurrence.may) {
              options.push('May');
            }
            if (template.recurrence.june) {
              options.push('Jun');
            }
            if (template.recurrence.july) {
              options.push('Jul');
            }
            if (template.recurrence.august) {
              options.push('Aug');
            }
            if (template.recurrence.september) {
              options.push('Sep');
            }
            if (template.recurrence.october) {
              options.push('Oct');
            }
            if (template.recurrence.november) {
              options.push('Nov');
            }
            if (template.recurrence.december) {
              options.push('Dec');
            }
          }
          return options.join(', ');
        default:
          return template.recurrence_type;
      }
    }
    return '-';
  };
};

let RecurrenceScheduleFilter = function (ReportService, TemplateService) {
  return function (schedule) {
    let name = '';

    if (schedule && !isNull(schedule.type_recurrence)) {
      switch (schedule.type_recurrence.toString()) {
        case 'document':
          name = 'Documents';
          break;
        case 'workflow':
          name = 'Workflows';
          break;
        case 'work-order':
          name = 'Work Orders';
          break;
        case ReportService.RECURRENCE_SCHEDULE_DAILY:
          name += 'Daily';
          if (schedule.conditions && (schedule.conditions.recurrence === 'every_x_days')) {
            name += ' - Every ' + schedule.conditions.every_x_days + ' days';
          }
          else {
            name += ' - Every weekday';
          }
          break;
        case ReportService.RECURRENCE_SCHEDULE_WEEKLY:
          name += 'Weekly';
          if (schedule.conditions) {
            name += ' - Every ' + schedule.conditions.every_x_weeks + ' weeks, '
              + TemplateService.RECURRENCE_WEEKLY_OPTIONS.find(d => d.id === parseInt(schedule.conditions.weekday)).name;
          }
          break;
        case ReportService.RECURRENCE_SCHEDULE_MONTHLY:
          name += 'Monthly';
          if (schedule.conditions && (schedule.conditions.month_type == 1)) {
            name += ' - ' + TemplateService.RECURRENCE_POSITION_IN_MONTH.find(d => d.id === parseInt(schedule.conditions.weekday_position_in_month)).name + ' '
              + TemplateService.RECURRENCE_WEEKLY_OPTIONS.find(d => d.id === parseInt(schedule.conditions.weekday)).name;
          }
          else if (schedule.conditions) {
            name += ' - ' + schedule.conditions.day_send + ' of every month';
          }
          break;
        case ReportService.RECURRENCE_SCHEDULE_YEARLY:
          name += 'Yearly';
          if (schedule.conditions && schedule.conditions.year_type == 1) {

            name += ' - ' + TemplateService.RECURRENCE_POSITION_IN_MONTH.find(d => d.id === parseInt(schedule.conditions.weekday_position_in_month)).name + ' '
              + TemplateService.RECURRENCE_WEEKLY_OPTIONS.find(d => d.id === parseInt(schedule.conditions.weekday)).name + ' of '
              + TemplateService.RECURRENCE_YEARLY_OPTIONS[parseInt(schedule.conditions.month_send) - 1];
          }
          else if (schedule.conditions) {
            name += ' - ' + TemplateService.RECURRENCE_YEARLY_OPTIONS[parseInt(schedule.conditions.month_send) - 1] + ', '
              + schedule.conditions.day_send;
          }
          break;
      }
    }
    return name;
  };
};

app.filter('recurrence', ['TemplateService', RecurrenceFilter]);
app.filter('recurrenceTemplate', ['TemplateService', RecurrenceTemplateFilter]);
app.filter('recurrenceSchedule', ['ReportService', 'TemplateService', RecurrenceScheduleFilter]);
